
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface AuthFormProps {
  onAuthSuccess: () => void;
}

const AuthForm = ({ onAuthSuccess }: AuthFormProps) => {
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  
  const handleEmailAuth = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsProcessing(true);

    try {
      // Always redirect to the /auth page for handling the callback
      const origin = window.location.origin;
      const redirectTo = `${origin}/auth`;
      
      console.log("Sending magic link with redirect to:", redirectTo);
      
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: redirectTo,
        },
      });

      if (error) throw error;

      toast({
        title: "Check your email",
        description: "We've sent you a login link. Click it to complete your signin.",
      });
    } catch (error) {
      console.error('Error sending magic link:', error);
      toast({
        title: "Error sending login link",
        description: "There was an error sending the login link. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 py-2">
      <p className="text-center text-muted-foreground">
        Enter your email address to sign in or create an account.
        We'll send you a secure login link.
      </p>
      <form onSubmit={handleEmailAuth} className="w-full max-w-sm space-y-4">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Button 
          type="submit" 
          className="w-full"
          disabled={isProcessing}
        >
          {isProcessing ? "Sending link..." : "Send login link"}
        </Button>
      </form>
    </div>
  );
};

export default AuthForm;
